
import React, { useState } from 'react';
import {
    Box,
    Card,
    Typography,
    Button,
    Divider,
    Grid,
    RadioGroup,
    Radio,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Checkbox,
    CardContent,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { MdCancel } from "react-icons/md";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form, Field } from "formik";
import { AiFillThunderbolt } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import "./BannerinputGetModal.css";
import LatestNewsImage from "../../../Assets/latestNewsImage.jpg";
import { adminUrl } from "../../../constants";





const ReadMoreModal = ({ readMoreModalContent, open, onClose, setSubmittedValues, submittedValues, modalHeadingName, handleNextModal }) => {

    console.log(readMoreModalContent, "readMoreModalContent")

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    maxWidth: "800px",
                    borderRadius: "14px",
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography className="custom-title-text" color='white'>
                                Blog

                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>

                <DialogContent
                    dividers
                    sx={{
                        padding: 0,
                        '& .MuiDialogContent-root': {
                            padding: 0,
                        },
                        color: "#7A7A7A",
                        // p: { xs: 2, md: "16px 24px" }
                    }}
                // sx={{ flexDirection: { xs: "column", md: "row" } }}

                >
                    <Box>
                        <Box
                            component="img"
                            src={`${adminUrl}${readMoreModalContent?.image}`}
                            sx={{ height: "300px", width: "100%" }}
                        >

                        </Box>
                        <CardContent>
                            <Box
                                sx={{
                                    display: "flex",
                                    // justifyContent: "space-between",

                                    alignItems: "center",
                                    color: "#C38F51",
                                    marginBottom: 0.5,
                                }}
                            >
                                <Typography variant="body1">
                                    {readMoreModalContent?.title}
                                </Typography>
                                {readMoreModalContent?.date && (
                                    <Typography
                                        variant="body1"
                                        sx={{ marginLeft: 4 }} // Add spacing between date and title
                                    >
                                        {readMoreModalContent.date}
                                    </Typography>
                                )}

                            </Box>

                            <Typography
                                variant="h6"
                                sx={{
                                    // fontWeight: "bold",
                                    marginBottom: 1,
                                    color: "#333",
                                    // fontSize: { xs: 18, md: 24 },
                                }}
                            >
                                {/* Discover the Golden Opportunity */}{readMoreModalContent?.secondary_title}
                                {/* {latestDates?.[0]?.additional_data?.card_design?.secondary_title} */}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#666",
                                    textAlign: "justify",
                                    marginBottom: 2,
                                    // fontSize: { xs: 12, md: 14 },
                                    lineHeight: 1.6,
                                    // height: { xs: "100px", md: "160px" }, // Set maximum text height
                                    overflow: "hidden", // Hide overflow text
                                }}
                            >
                                {/* {latestDates?.[0]?.additional_data?.card_design?.content} */}
                                {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using ‘Content here, content here’, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for ‘lorem ipsum’ will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                                Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of “de Finibus Bonorum et Malorum” (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, “Lorem ipsum dolor sit amet..”, comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from “de Finibus Bonorum et Malorum” by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham. Where can I get some? There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don’t look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn’t anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. */}
                                {readMoreModalContent?.textContent}
                            </Typography>


                        </CardContent>
                    </Box>


                </DialogContent>
            </Box>
        </Dialog >
    );
};

export default ReadMoreModal;
